(function ($) {
	/* ---------------------------------------
		ページトップ
	--------------------------------------- */
	$(function () {
		var totop = $('.page_top .totop');
		totop.click(function () {
			$('body, html').animate({ scrollTop: 0 }, 500);
			return false;
		});
		var page_top = $('.page_top');
		page_top.hide();
		$(window).scroll(function () {
			if ($(this).scrollTop() > 400) {
				page_top.fadeIn();
			} else {
				page_top.fadeOut();
			}
		});
	});

	/* ---------------------------------------
		スムースリンク
	--------------------------------------- */
	$(function () {
		$('a[href^="#"]').click(function () {
			var href = $(this).attr("href");
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top;
			var speed = 500;
			$("html, body").animate({
				scrollTop: position
			}, speed, "swing");
			return false;
		});
	});

	/* ---------------------------------------
		object fit ie
	--------------------------------------- */
	objectFitImages('.objectfit img, .img_trim img');

	/* ---------------------------------------
		fancybox
	--------------------------------------- */
	$('[data-fancybox^="gallery"]').fancybox({
		buttons: [
			'thumbs',
			'close'
		],
		animationEffect: 'fade'
	});
	$(function () {
		var images = $('[class*="wp-image-"]');
		images.parent('a').attr({
			'data-fancybox': '',
		});
		var images = $('.wp-block-gallery a');
		images.attr({
			'data-fancybox': 'images',
			'data-type': 'image',
		});
		console.log(images);
		$("[data-fancybox]").fancybox({
			loop: true,
			buttons: [
				'thumbs',
				'close',
			],
		});
	});

	/* ---------------------------------------
		ページ遷移時にフェードイン・アウト
	--------------------------------------- */
	// $('body').removeClass('fadeout');

	/* ---------------------------------------
	end
	--------------------------------------- */
})(jQuery);

/* ---------------------------------------
	アコーディオン
--------------------------------------- */
(function ($) {
	var accordionContainer = $('.accordion_container');
	var accordionItem = $('.accordion_item');
	var accordionTitle = $('.accordion_title');
	var accordionContent = $('.accordion_content');
	accordionContent.css("display", "none");
	var w = $(window).width();
	var headH = 0;
	if (w <= 600) {
		var headH = $('.header').outerHeight();
		var headH = headH;
	}
	accordionTitle.click(function () {
		var clicks = $(this).data('clicks');
		$(this).toggleClass('open');
		$(this).next().slideToggle();
		if (clicks) {
		} else {
			var top = $(this).offset().top - headH;
			$('html,body').animate({ scrollTop: top }, 500);
		}
		$(this).data("clicks", !clicks);
	});

	/* ---------------------------------------
		fancybox
	--------------------------------------- */
	var images = $('.wp-block-image a, .wp-block-gallery a');
	if (images.length) {
		images.attr({
			'data-fancybox': ''
		});
		$("[data-fancybox]").fancybox({
			loop: true,
			buttons: [
				'close',
			],
			animationEffect: 'fade'
		});
	}
})(jQuery);